module.exports = __webpack_public_path__ + "static/media/h5_yoga_pic3.777192cc.png";